import { render, staticRenderFns } from "./CampaignUserBuktiTayang.vue?vue&type=template&id=1f893daf&scoped=true"
import script from "./CampaignUserBuktiTayang.vue?vue&type=script&lang=js"
export * from "./CampaignUserBuktiTayang.vue?vue&type=script&lang=js"
import style0 from "./CampaignUserBuktiTayang.vue?vue&type=style&index=0&id=1f893daf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f893daf",
  null
  
)

export default component.exports